export default "__VITE_ASSET__CNMD1ghW__"